import React, { useState } from 'react';
import { motion } from 'framer-motion';

const TechOutcomes = ({ title, description, outcomes = [] }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section 
      className="py-24 px-6 md:px-12 relative overflow-hidden bg-white"
    >
      <div className="max-w-[1240px] mx-auto relative z-10">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            {title}
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {description}
          </p>
        </motion.div>

        {/* Numbered Sequence Rows (No Cards) */}
        <div 
          className="flex flex-col mt-12 border-t"
          style={{ borderColor: 'rgba(0, 0, 0, 0.08)' }}
        >
          {outcomes.map((outcome, index) => {
            const formattedIndex = String(index + 1).padStart(2, '0');
            return (
              <motion.div
                key={index}
                className="flex py-10 border-b items-start transition-all duration-300 hover:pl-4"
                style={{
                  borderBottomColor: 'rgba(0, 0, 0, 0.08)',
                  backgroundColor: hoveredIndex === index ? 'rgba(0, 198, 255, 0.04)' : 'transparent'
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <div 
                  className="text-4xl md:text-5xl font-extrabold leading-none mr-6 md:mr-12 w-20 transition-all duration-300 text-left"
                  style={{
                    color: hoveredIndex === index ? '#00c6ff' : 'rgba(0, 198, 255, 0.15)',
                    transform: hoveredIndex === index ? 'scale(1.1)' : 'scale(1)'
                  }}
                >
                  {formattedIndex}
                </div>
                <div className="flex-1 grid grid-cols-1 md:grid-cols-[280px_1fr] gap-3 md:gap-8 items-center">
                  <h3 
                    className="text-xl md:text-2xl font-bold text-left m-0 text-gray-900"
                  >
                    {outcome.title}
                  </h3>
                  <p 
                    className="text-[15px] md:text-[16px] leading-relaxed text-left m-0 text-gray-600"
                  >
                    {outcome.text}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechOutcomes;
